import React from 'react';
import { AlertTriangle, Clock, Battery } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#FDF6EC] text-[#2C1810]" data-id="element-141">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-142">
        {/* The Hook */}
        <div className="text-center mb-16" data-id="element-143">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-144">
            ¿Llegas a casa a las 6:30 PM tan agotada que lo único que quieres es{' '}
            <span className="text-[#D4522A] underline decoration-4 decoration-[#F5A623]" data-id="element-145">
              pedir pizza
            </span>
            ?
          </h2>
          <p className="font-body text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-146">
            Te entiendo. Vivir en Estados Unidos es una carrera contra el reloj.
          </p>
        </div>

        {/* The Agitation */}
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border-t-8 border-[#D4522A] relative overflow-hidden" data-id="element-147">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#F5A623] opacity-10 rounded-bl-full" data-id="element-148"></div>

          <div className="space-y-6 font-body text-lg text-gray-800 leading-relaxed" data-id="element-149">
            <p data-id="element-150">
              Trabajas duro, cuidas a los tuyos, y cuando finalmente llegas a
              casa, lo último que quieres es pasar{' '}
              <strong data-id="element-151">2 horas frente a la estufa</strong> o pesando comida en
              una báscula.
            </p>

            <p data-id="element-152">La realidad es cruel:</p>

            <ul className="space-y-4 my-6" data-id="element-153">
              <li className="flex items-start gap-4" data-id="element-154">
                <div className="bg-red-100 p-2 rounded-full text-[#D4522A] mt-1" data-id="element-155">
                  <AlertTriangle className="w-5 h-5" data-id="element-156" />
                </div>
                <span data-id="element-157">
                  O comes algo rápido (y te sientes culpable y pesada al día
                  siguiente).
                </span>
              </li>
              <li className="flex items-start gap-4" data-id="element-158">
                <div className="bg-red-100 p-2 rounded-full text-[#D4522A] mt-1" data-id="element-159">
                  <Battery className="w-5 h-5" data-id="element-160" />
                </div>
                <span data-id="element-161">
                  O intentas una "dieta americana" de lechuga y pollo sin sabor
                  que abandonas a los tres días porque extrañas tu sazón.
                </span>
              </li>
            </ul>

            <div className="bg-[#FFF8E1] p-6 rounded-xl border-l-4 border-[#F5A623] mt-8" data-id="element-162">
              <p className="font-bold text-[#2C1810] text-xl mb-2" data-id="element-163">
                Ese es el problema:
              </p>
              <p className="text-gray-700" data-id="element-164">
                Las dietas tradicionales no fueron diseñadas para la mujer
                latina que vive en EE.UU. Te piden que renuncies a tu cultura
                para estar delgada.
              </p>
            </div>
          </div>
        </div>

        {/* Transition */}
        <div className="text-center mt-16" data-id="element-165">
          <p className="font-heading text-2xl font-bold text-[#2D6A4F]" data-id="element-166">
            Pero hay una mejor manera...
          </p>
        </div>
      </div>
    </section>;
}